<template lang="pug">
#onlyOfficeContainer(v-if="viewType === 'onlyOffice'")
  onlyoffice(:fileInfo="fileInfo")
#officeContainer(v-else v-loading='loading'
  element-loading-text='文档加载中...'
  element-loading-background='rgba(244, 245, 250, 1)')
  iframe(ref='iframeID')
  application(ref='docApplication' type="office" v-if="docloaded")
</template>

<script>
import { creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeService from '@/CommonDP/mongeView/service/monge-service';
import application from "@/views/mongeView/application.vue";
import onlyoffice from "@/CommonDP/mongeView/docmentView/onlyoffice.vue";
export default {
  components: { application, onlyoffice },
  data () {
    return {
      loading: true,
      docloaded: false,
      viewType: "officeOnline",
      fileInfo: {}
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },

  mounted() {
    this.getFileInfo();
  },

  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      mongeMutations.setShareId(i);
      // 查询预览工具
      const viewTypeRes = await mongeService.getofficeViewType();
      this.viewType = viewTypeRes.data || "officeOnline";
      // 查询文件信息, 并设置参数
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const fileInfo = { fileId, fileVersion, sharerId, i, title: data.fileName, ...data };
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      if (this.viewType === "onlyOffice") {
      // 设置 onlyOffice 的参数
        this.fileInfo = fileInfo;
      } else {
        // 如果使用 office online 预览文件,则继续初始化
        await this.getRequestData(sharerId);
      }
    },
    async getRequestData(sharerId) {
      const domBox = this.$refs.iframeID;
      domBox.onerror = () => {
        this.loadingTxt = '文档加载失败';
      };
      domBox.onload = () => {
        this.loading = false;
        this.docloaded = true;
        // 加水印
        addWaterMarker(document.body, creatWatermarkUserInfo());
      };
      try {
        const otherData = this.docmentData;
        const result = await mongeService.getoffice(otherData.fileId, otherData.fileVersion);
        domBox.src = result.data;
      } catch (e) {
        console.error("获取 office 预览地址失败", e);
        this.$message.warning('office地址获取失败');
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#onlyOfficeContainer {
  padding: 0 !important;
  width: 100%;
  height: calc(100vh - 180px);
}
</style>
<style lang="scss" scoped>
#officeContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>

